<template>
  <div class="d-flex" style="gap: 8px; padding: 0">
    <b-button size="sm" @click="onClickEditButton" class="aktionenButton">
      <Pencil :size="14" style="color: black; padding: 0" />
    </b-button>
    <b-button size="sm" @click="onClickWheelButton" class="aktionenButton">
      <Settings :size="14" style="padding: 0" />
    </b-button>
    <b-button size="sm" @click="onClickDeleteButton" class="aktionenButton">
      <Trash2 :size="14" style="padding: 0" />
    </b-button>
  </div>
</template>
<script>
import { SET_REISETERMIN_EDIT_DATA } from '@/core/produkte/reisetermine/stores/reiseterminplanung.module';
import apiService from '@/core/common/services/api.service';
import { Pencil, Settings, Trash2 } from 'lucide-vue';

export default {
  components: { Pencil, Settings, Trash2 },
  props: {},
  data() {},
  methods: {
    onClickEditButton() {
      this.params.api.deselectAll();
      this.$store.commit(SET_REISETERMIN_EDIT_DATA, this.params.data);
      this.$root.$emit('bv::show::modal', 'modalReiseterminBearbeiten');
    },
    onClickWheelButton() {
      window.open('/#/reisen/' + this.params.data.reise.reisekuerzel + '/reisestammdaten', '_blank');
    },
    async onClickDeleteButton() {
      const confirmed = await this.$bvModal.msgBoxConfirm('Willst du den Reisetermin wirklich löschen?', {
        title: 'Reisetermin löschen',
        footerClass: 'modal-footer--centered',
        centered: true,
        okTitle: 'OK',
        cancelTitle: 'Abbrechen',
      });
      if (confirmed && this.params.data.id) {
        apiService
          .delete('/reisetermin', {
            reisekuerzel: this.params.data.reiseterminkuerzel.substring(0, 6),
            startdatum: this.params.data.startdatum,
          })
          .then(_ => {
            this.params.api.onFilterChanged();
          });
      }
    },
  },
};
</script>
<style scoped>
.aktionenButton {
  width: 24px;
  height: 24px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
